/**
 * @generated SignedSource<<4c1f15eb34c2e65829796ec279053f28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InitiatedBy = "BITPANDA_CORPORATE_ACTION" | "BITPANDA_MANUAL_TRADE" | "BITPANDA_SAVINGS" | "BITPANDA_SWAPS" | "ORDER" | "OTHER" | "USER";
export type LegalClassification = "ARTS" | "EMTS" | "NONE" | "OTHER";
export type TransactionCategory = "CORPORATE_ACTION" | "CRYPTO_ACTION" | "CRYPTO_TRANSFER" | "FIAT_TRANSFER" | "NON_USER_INITIATED" | "STAKING" | "TRADE";
export type TransactionDirection = "INCOMING" | "OUTGOING";
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type TransactionInput = {
  externalTransactionId?: string | null | undefined;
  tradeId?: string | null | undefined;
  tradeOfferId?: string | null | undefined;
};
export type TransactionViewQuery$variables = {
  input: TransactionInput;
};
export type TransactionViewQuery$data = {
  readonly transaction: {
    readonly __typename: string;
    readonly asset: {
      readonly __typename: string;
      readonly id: string;
      readonly legalClassification: LegalClassification | null | undefined;
      readonly logoUrl: string | null | undefined;
      readonly minimumSellAmount: PrecisionFloat | null | undefined;
      readonly name: string | null | undefined;
      readonly portfolio: {
        readonly fiatBalance: PrecisionFloat | null | undefined;
      } | null | undefined;
      readonly symbol: string | null | undefined;
    } | null | undefined;
    readonly assetAmount: PrecisionFloat | null | undefined;
    readonly assetPrice: PrecisionFloat | null | undefined;
    readonly category: TransactionCategory;
    readonly direction: TransactionDirection | null | undefined;
    readonly fiat: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly symbol: string | null | undefined;
    } | null | undefined;
    readonly fiatAmount: PrecisionFloat | null | undefined;
    readonly id: string;
    readonly initiatedBy: InitiatedBy | null | undefined;
    readonly spread: PrecisionFloat | null | undefined;
    readonly status: TransactionStatus | null | undefined;
    readonly taxAmount: PrecisionFloat | null | undefined;
    readonly time: TimeScalar | null | undefined;
    readonly totalAmount: PrecisionFloat | null | undefined;
  } | null | undefined;
};
export type TransactionViewQuery = {
  response: TransactionViewQuery$data;
  variables: TransactionViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "transaction",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "legalClassification",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetPortfoliosConnection",
            "kind": "LinkedField",
            "name": "portfolio",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatBalance",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumSellAmount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Fiat",
        "kind": "LinkedField",
        "name": "fiat",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spread",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fiatAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "time",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "initiatedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "direction",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionViewQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionViewQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "6424194b4b55965fc383f4df842c78c4",
    "id": null,
    "metadata": {},
    "name": "TransactionViewQuery",
    "operationKind": "query",
    "text": "query TransactionViewQuery(\n  $input: TransactionInput!\n) {\n  transaction(input: $input) {\n    id\n    asset {\n      __typename\n      id\n      symbol\n      logoUrl\n      legalClassification\n      name\n      portfolio {\n        fiatBalance\n      }\n      minimumSellAmount\n    }\n    fiat {\n      id\n      name\n      symbol\n    }\n    spread\n    assetAmount\n    fiatAmount\n    status\n    time\n    initiatedBy\n    assetPrice\n    taxAmount\n    totalAmount\n    category\n    direction\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d8b2afe86e57c1103a4578d7e78ed69";

export default node;
